(function () {
  if (window.GolfDaddyProductGalleryLoaded) return;
  window.GolfDaddyProductGalleryLoaded = true;

  const selectors = {
    gallery: ".product__gallery",
    mainSlider: ".mySwiper2",
    thumbSlider: ".mySwiper",
    pagination: ".js-product-gallery-pagination",
    prevButton: ".js-product-gallery-prev",
    nextButton: ".js-product-gallery-next"
  };

  const pauseGalleryMedia = (galleryEl) => {
    if (!galleryEl) return;

    galleryEl.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    });

    galleryEl.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow?.postMessage('{"method":"pause"}', "*");
    });

    galleryEl.querySelectorAll("video").forEach((video) => {
      video.pause();
    });

    galleryEl.querySelectorAll("product-model").forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  };

  const ensureVideoAutoplay = (videoEl) => {
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.setAttribute("muted", "");
    videoEl.setAttribute("playsinline", "");
    videoEl.setAttribute("webkit-playsinline", "");
  };

  const syncPosterState = (video, posterHost) => {
    if (!video || !posterHost || posterHost.dataset.playListeners) return;

    posterHost.dataset.playListeners = "true";
    video.addEventListener("playing", () => {
      posterHost.classList.add("is-playing");
    });
    video.addEventListener("pause", () => {
      posterHost.classList.remove("is-playing");
    });
    video.addEventListener("ended", () => {
      posterHost.classList.remove("is-playing");
    });
  };

  const loadDeferredMedia = (deferredMedia) => {
    if (!deferredMedia) return;

    const mediaEl = deferredMedia.querySelector("video, model-viewer, iframe");
    if (deferredMedia.hasAttribute("loaded") && mediaEl) return;
    if (deferredMedia.hasAttribute("loaded") && !mediaEl) {
      deferredMedia.removeAttribute("loaded");
    }

    const template = deferredMedia.querySelector("template");
    const templateContent = template?.content?.firstElementChild;
    if (!templateContent) return;

    const content = document.createElement("div");
    content.appendChild(templateContent.cloneNode(true));

    const loadedMediaEl = content.querySelector("video, model-viewer, iframe");
    if (!loadedMediaEl) return;

    deferredMedia.setAttribute("loaded", true);
    deferredMedia.appendChild(loadedMediaEl);
  };

  const playVideo = (video, posterHost) => {
    ensureVideoAutoplay(video);
    if (posterHost) posterHost.classList.add("is-playing");

    const playPromise = video.play();
    if (!playPromise || !playPromise.catch) return;

    playPromise.catch(() => {
      if (posterHost) posterHost.classList.remove("is-playing");

      video.addEventListener(
        "canplay",
        () => {
          ensureVideoAutoplay(video);
          if (posterHost) posterHost.classList.add("is-playing");

          const retry = video.play();
          if (retry && retry.catch) {
            retry.catch(() => {
              if (posterHost) posterHost.classList.remove("is-playing");
            });
          }
        },
        { once: true }
      );
    });
  };

  const playActiveSlideMedia = (swiperInstance) => {
    if (!swiperInstance) return;

    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (!activeSlide) return;

    const deferredMedia = activeSlide.querySelector(".deferred-media");
    if (deferredMedia) {
      const hasMediaEl = deferredMedia.querySelector("video");

      if (deferredMedia.hasAttribute("loaded") && !hasMediaEl) {
        deferredMedia.removeAttribute("loaded");
      }

      loadDeferredMedia(deferredMedia);
    }

    window.setTimeout(() => {
      const video = activeSlide.querySelector("video");
      if (!video) return;

      const posterHost = video.closest(".deferred-media[data-autoplay-poster]");
      syncPosterState(video, posterHost);
      playVideo(video, posterHost);
    }, 100);
  };

  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.productGalleryInitialized === "true") return;
    if (typeof Swiper === "undefined") return;

    const thumbSlider = gallery.querySelector(selectors.thumbSlider);
    const mainSlider = gallery.querySelector(selectors.mainSlider);

    if (!thumbSlider || !mainSlider) return;

    const thumbsWrapper = gallery.querySelector(".ccsliderWrap");
    const thumbsPosition = thumbsWrapper?.dataset.thumbsPosition || "bottom";
    const thumbsIsVertical = thumbsPosition === "left" && window.innerWidth >= 992;
    let main;
    const scheduleMainUpdate = () => {
      window.requestAnimationFrame(() => {
        if (!main) return;
        main.update();
      });
    };

    const thumbs = new Swiper(thumbSlider, {
      spaceBetween: thumbsIsVertical ? 8 : 16,
      slidesPerView: "auto",
      allowTouchMove: false,
      direction: thumbsIsVertical ? "vertical" : "horizontal",
      watchSlidesProgress: true
    });

    main = new Swiper(mainSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 360,
      threshold: 10,
      touchAngle: 30,
      navigation: {
        nextEl: gallery.querySelector(selectors.nextButton),
        prevEl: gallery.querySelector(selectors.prevButton)
      },
      pagination: {
        el: gallery.querySelector(selectors.pagination),
        type: "bullets",
        clickable: true
      },
      thumbs: {
        swiper: thumbs
      },
      loop: true,
      on: {
        slideChangeTransitionStart() {
          if (this.realIndex !== this._prevGalleryRealIndex) {
            this._prevGalleryRealIndex = this.realIndex;
            pauseGalleryMedia(this.el);
          }
        },
        slideChangeTransitionEnd() {
          playActiveSlideMedia(this);
        }
      }
    });

    gallery.dataset.productGalleryInitialized = "true";
    thumbsWrapper?.classList.remove("ig-gallery-hidden");
    mainSlider.querySelectorAll("img").forEach((image) => {
      if (image.complete) return;
      image.addEventListener("load", scheduleMainUpdate, { once: true });
      image.addEventListener("error", scheduleMainUpdate, { once: true });
    });
    scheduleMainUpdate();

    window.addEventListener("load", () => {
      scheduleMainUpdate();
      const videoMedia = gallery.querySelector('.deferred-media[data-media-type="video"]');
      if (!videoMedia) return;

      loadDeferredMedia(videoMedia);

      window.setTimeout(() => {
        playActiveSlideMedia(main);
      }, 200);
    });
  };

  let swiperReadyAttempts = 0;
  let swiperFallbackLoading = false;
  const revealGalleryFallback = () => {
    document.querySelectorAll(".ccsliderWrap.ig-gallery-hidden").forEach((galleryWrap) => {
      galleryWrap.classList.remove("ig-gallery-hidden");
    });
  };

  const loadSwiperFallback = () => {
    if (swiperFallbackLoading || typeof Swiper !== "undefined") return;

    const existingSwiperScript = document.querySelector('script[src*="swiper.js"]');
    if (!existingSwiperScript?.src) return;

    swiperFallbackLoading = true;
    const fallbackScript = document.createElement("script");
    fallbackScript.src = existingSwiperScript.src;
    fallbackScript.async = true;
    fallbackScript.onload = init;
    fallbackScript.onerror = () => {
      swiperFallbackLoading = false;
    };
    document.head.appendChild(fallbackScript);
  };

  const init = () => {
    if (typeof Swiper === "undefined") {
      revealGalleryFallback();
      loadSwiperFallback();
      swiperReadyAttempts += 1;
      if (swiperReadyAttempts <= 80) {
        window.setTimeout(init, 100);
      }
      return;
    }

    document.querySelectorAll(selectors.gallery).forEach(initGallery);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  window.addEventListener("load", init);
  document.addEventListener("shopify:section:load", init);
})();
